"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initDeviceUUID = initDeviceUUID;
exports.getDeviceUUID = getDeviceUUID;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
//TODO convertirlo a un objeto de información del dispositivo y usar un store base de web-ui-framework
async function initDeviceUUID() {
    const deviceUUID = await (0, web_ui_framework_1.getDeviceUUID)();
    localStorage.setItem('deviceUUID', deviceUUID);
    return Promise.resolve(deviceUUID);
}
async function getDeviceUUID() {
    const deviceUUID = localStorage.getItem('deviceUUID');
    if (deviceUUID) {
        return Promise.resolve(deviceUUID);
    }
    return initDeviceUUID();
}
//# sourceMappingURL=deviceUUID.js.map